module.exports={clientId:"T7Hkb0HjF3d3BA",userName:"Tim3303",probationMods:["_Diabetes","fatalgift"]};